import { Stack } from '../../../../../design-system/stack/stack';
import { CategoryView } from '../../../../../types/entity-types';
import { BeneficiaryDetails } from '../utils/beneficiary-utils';
import { Metric } from '../utils/get-transaction-summary-metrics';
import { ChangeVendorCategory } from './change-vendor-category';
import { VendorInformation } from './vendor-information';
import { VendorTransactionsSummary } from './vendor-transactions-summary';

type VendorSectionProps = {
  isCredit: boolean;
  beneficiary: BeneficiaryDetails | null;
  vendorLogo: string;
  vendorName: string;
  vendorDescription?: string | null;
  transactionSummaryMetrics: Metric[];
  category?: CategoryView;
  categories: CategoryView[];
  onEditVendor: () => void;
  onChangeVendor: () => void;
  onChangeCategory: (categoryId: string) => void;
};

export const VendorSection = ({
  isCredit,
  beneficiary,
  vendorLogo,
  vendorName,
  vendorDescription,
  category,
  transactionSummaryMetrics,
  categories,
  onEditVendor,
  onChangeVendor,
  onChangeCategory,
}: VendorSectionProps) => {
  return (
    <Stack space={4}>
      <p className="text-base leading-[22px] font-medium tracking-[-0.02em]">{isCredit ? 'From' : 'To'}</p>
      <VendorInformation
        beneficiary={beneficiary}
        vendorLogo={vendorLogo}
        vendorName={vendorName}
        vendorDescription={vendorDescription}
        onEditVendor={onEditVendor}
        onChangeVendor={onChangeVendor}
      />
      <ChangeVendorCategory category={category} categories={categories} onValueChange={onChangeCategory} />
      <VendorTransactionsSummary metrics={transactionSummaryMetrics} />
    </Stack>
  );
};
